import ReduxThunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import { userReducer } from './reducer';

//Create a middleware
const createStoreMiddleware= applyMiddleware(ReduxThunk)(createStore);

//Create store for middleware
export const userStore= createStoreMiddleware(userReducer);


// WEBPACK FOOTER //
// ./web/store.jsx